document.addEventListener('DOMContentLoaded', function () {

  /* ---------- Scroll reveal ---------- */
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.18 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* ---------- Stagger index for grouped reveals ---------- */
  document.querySelectorAll('.reveal-stagger').forEach(function (group) {
    Array.prototype.forEach.call(group.children, function (child, i) {
      child.style.setProperty('--stagger-index', i);
    });
  });

  /* ---------- Count-up stat ---------- */
  var statEls = document.querySelectorAll('[data-count-to]');
  if ('IntersectionObserver' in window && statEls.length) {
    var statIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var target = parseFloat(el.getAttribute('data-count-to')) || 0;
        var suffix = el.getAttribute('data-count-suffix') || '';
        var duration = 1400;
        var start = null;

        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(target * eased) + suffix;
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
        statIO.unobserve(el);
      });
    }, { threshold: 0.5 });
    statEls.forEach(function (el) { statIO.observe(el); });
  }

  /* ---------- Option cards (quantity / bundle selection) ---------- */
  document.querySelectorAll('[data-option-group]').forEach(function (group) {
    var cards = group.querySelectorAll('.option-card, .freq-option');
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        cards.forEach(function (c) { c.classList.remove('is-selected'); });
        card.classList.add('is-selected');
        var priceTarget = document.querySelector('[data-price-display]');
        var newPrice = card.getAttribute('data-price');
        if (priceTarget && newPrice) { priceTarget.textContent = newPrice; }
      });
    });
  });

  /* ---------- Sticky add-to-cart (mobile) ---------- */
  var stickyAtc = document.querySelector('.sticky-atc');
  var atcTrigger = document.querySelector('[data-atc-trigger]');
  if (stickyAtc && atcTrigger && 'IntersectionObserver' in window) {
    var atcIO = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyAtc.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    atcIO.observe(atcTrigger);
  }

  /* ---------- Product gallery thumbnails ---------- */
  document.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var main = document.querySelector('[data-gallery-main]');
      if (main) { main.src = thumb.getAttribute('data-full-src') || thumb.src; }
    });
  });

  /* ---------- Sticky header scroll state ---------- */
  var header = document.querySelector('.site-header');
  if (header) {
    window.addEventListener('scroll', function () {
      header.classList.toggle('is-scrolled', window.scrollY > 10);
    }, { passive: true });
  }

  /* ---------- Cart drawer (real AJAX cart) ---------- */
  var cartDrawer = document.getElementById('cart-drawer');
  var cartBody = document.querySelector('[data-cart-body]');
  var cartSubtotal = document.querySelector('[data-cart-subtotal]');

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    refreshCartDrawer();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function renderCart(cart) {
    if (!cartBody) return;
    if (!cart.items.length) {
      cartBody.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
    } else {
      cartBody.innerHTML = cart.items.map(function (item, i) {
        return '<div class="cart-drawer__item">' +
          '<img src="' + (item.image || '') + '" alt="' + item.product_title + '">' +
          '<div>' +
            '<p class="cart-drawer__item-title">' + item.product_title + '</p>' +
            '<p class="cart-drawer__item-variant">' + (item.variant_title || '') + '</p>' +
            '<div class="cart-drawer__item-qty">' +
              '<button data-cart-qty-decrease data-line="' + (i + 1) + '" data-qty="' + (item.quantity - 1) + '">&minus;</button>' +
              '<span>' + item.quantity + '</span>' +
              '<button data-cart-qty-increase data-line="' + (i + 1) + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
            '</div>' +
            '<button class="cart-drawer__item-remove" data-cart-remove data-line="' + (i + 1) + '">Remove</button>' +
          '</div>' +
          '<p class="cart-drawer__item-price">' + formatMoney(item.final_line_price) + '</p>' +
        '</div>';
      }).join('');
    }
    if (cartSubtotal) cartSubtotal.textContent = formatMoney(cart.total_price);
    var cartCountEl = document.querySelector('[data-cart-count]');
    if (cartCountEl) cartCountEl.textContent = cart.item_count;
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function refreshCartDrawer() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(renderCart);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-open]')) {
      e.preventDefault();
      openCartDrawer();
    }
    if (e.target.closest('[data-cart-close]')) {
      closeCartDrawer();
    }
    if (e.target.closest('[data-cart-remove]')) {
      var line = e.target.closest('[data-cart-remove]').getAttribute('data-line');
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      }).then(function (r) { return r.json(); }).then(renderCart);
    }
    if (e.target.closest('[data-cart-qty-increase], [data-cart-qty-decrease]')) {
      var btn = e.target.closest('[data-cart-qty-increase], [data-cart-qty-decrease]');
      var line2 = btn.getAttribute('data-line');
      var qty = btn.getAttribute('data-qty');
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line2, quantity: qty })
      }).then(function (r) { return r.json(); }).then(renderCart);
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCartDrawer();
  });

  /* Intercept product form submissions. Main OREVEO form goes straight to checkout; other forms keep the cart drawer. */
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();

    var formData = new FormData(form);
    var submitButton = form.querySelector('[type="submit"]');
    if (submitButton) submitButton.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Unable to add product');
        return r.json();
      })
      .then(function () {
        if (form.hasAttribute('data-direct-checkout')) {
          window.location.assign('/checkout');
          return;
        }
        if (submitButton) submitButton.disabled = false;
        openCartDrawer();
      })
      .catch(function () {
        if (submitButton) submitButton.disabled = false;
        form.submit();
      });
  });

  /* ---------- Mobile nav toggle ---------- */
  var navToggle = document.querySelector('.site-header__mobile-toggle');
  var nav = document.querySelector('.site-header__nav');
  if (navToggle && nav) {
    navToggle.addEventListener('click', function () {
      nav.classList.toggle('is-open');
    });
  }
});
